// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"973fb7c1","416":"36022c08"}[chunkId] + ".chunk.js";
};